import {useEffect, useRef, useState} from 'react';

import Icon from 'components/Icon/Icon';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {debounce} from 'lodash';

import {getAllBeersACS} from '../requestAC';
import {setChangeSearchAC, setCurrentPageAC, setCurrentSearchAC, setFallbackSearchAC} from '../slice';
import Table from '../Table/Table';

import './AddBeers.scss';

const AddBeers = () => {
  const {changeSearch, fallbackSearch, currentPage, allBeers, currentSearch} = useGlobalState(
    (state) => state.beersManager,
  );

  const inputRef = useRef<HTMLInputElement | null>(null);
  const [search, setSearch] = useState('');

  const dispatch = useSetGlobalState();

  useEffect(() => {
    const data = {page: currentPage, perPage: 15, name: ''};

    if (changeSearch) {
      if (inputRef.current) {
        inputRef.current.value = fallbackSearch;
        setSearch(fallbackSearch);
      }
      dispatch(setChangeSearchAC(false));
    }

    if (search !== '') data.name = search;

    dispatch(getAllBeersACS(data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, changeSearch, search, currentPage]);

  const handleSearch = (name: string) => {
    const payload = {page: currentPage, perPage: 15, name};

    dispatch(setCurrentSearchAC(name));
    if (name !== currentSearch) dispatch(setCurrentPageAC(1));
    if (allBeers[0]?.attributes?.name) dispatch(setFallbackSearchAC(allBeers[0].attributes.name));

    dispatch(getAllBeersACS(payload));
  };

  const debouncedSearch = debounce(handleSearch, 500);

  return (
    <div className="add-beers">
      <div className="add-beers__header">
        <div className="search">
          <input
            ref={inputRef}
            className="search__field"
            placeholder="Search Beers"
            onChange={(e) => debouncedSearch(e.target.value)}
          />
          <Icon icon="search" />
        </div>
      </div>
      <div className="add-beers__table">
        <Table beersList={allBeers} />
      </div>
    </div>
  );
};

export default AddBeers;
